import { useCallback, useEffect, useMemo, useRef, useState } from "react";

export const useTableHover = (tableData: Array<{ isPrimary?: boolean }> = []) => {
    const [selectedRow, setSelectedRow] = useState<null | number>(null);
    const wasPrimarySelected = useRef<boolean>(false);
    const primaryIndex = useMemo(() => tableData.findIndex(({ isPrimary }) => isPrimary), [tableData]);

    useEffect(() => {
        if (primaryIndex === -1 || wasPrimarySelected.current) {
            return;
        }

        setSelectedRow(primaryIndex);
        wasPrimarySelected.current = true;
    }, [primaryIndex, tableData]);

    const onRowHover = useCallback((rowNumber: number) => {
        setSelectedRow(rowNumber);
    }, []);

    const onLeave = useCallback(() => {
        setSelectedRow(null);
        // for corner case when primary was last hovered on the chart
        setTimeout(() => setSelectedRow(primaryIndex), 0);
    }, [primaryIndex]);

    return {
        activeRowIndex: selectedRow == null || isNaN(selectedRow) ? -1 : selectedRow,
        onLeave,
        onRowHover,
        primaryIndex,
        selectedRow,
        setSelectedRow,
    };
};
